import Localize from 'react-intl-universal';

import * as yup from 'yup';

import { MAIL_REGEX, PHONE_REGEX } from '@common/Constants';

export default () => {
  return yup.object().shape({
    information: yup.object().shape({
      firstName: yup.string(),
      lastName: yup.string(),
      academicTitle: yup.string(),
      birthDate: yup.string().nullable().notRequired()
    }),
    organizationalData: yup.object().shape({
      departmentName: yup.string(),
      job: yup.string(),
      companyName: yup.string(),
      personalNumber: yup.number().typeError(Localize.get('Validation.numberFilter')).nullable(),
      costCenter: yup.string()
    }),
    emails: yup.array().of(
      yup.object().shape({
        type: yup.string(),
        email: yup
          .string()
          .email(Localize.get('Validation.emailFilter'))
          .matches(MAIL_REGEX, Localize.get('Validation.emailFilter'))
          .nullable(true)
      })
    ),
    addresses: yup.array().of(
      yup.object().shape({
        type: yup.string(),
        number: yup
          .string()
          .matches(/^[a-zA-Z0-9_]*$/, Localize.get('Validation.numberFilter'))
          .typeError(Localize.get('Validation.numberFilter')),
        postCode: yup.string().typeError(Localize.get('Validation.numberFilter')),
        poBox: yup.number().typeError(Localize.get('Validation.numberFilter'))
      })
    ),
    communications: yup.array().of(
      yup.object().shape({
        type: yup.string(),
        phone: yup
          .string()
          .matches(PHONE_REGEX, Localize.get('Validation.phoneFormat'))
          .min(9, Localize.get('Validation.short'))
          .typeError(Localize.get('Validation.numberFilter'))
      })
    )
  });
};
